import React from "react";
import { NavLink } from "react-router-dom";
import { GridIcon, MapIcon } from "@components/icons";

function ViewTypeButton() {
  return (
    <div>
      <NavLink
        to={`/projects`}
        className="ts-Breadcrumb-icon btn"
        // activeClassName="text-primary"
        aria-label="grid"
        view="grid"
        data-testid="gridViewButton"
        title="Grid view"
      >
        <GridIcon />
      </NavLink>
      <NavLink
        to={`/projects/mapview`}
        className="ts-Breadcrumb-icon btn "
        // activeClassName="text-primary"
        aria-label="map"
        data-testid="mapViewButton"
        title="Map view"
      >
        <MapIcon view="map" />
      </NavLink>
    </div>
  );
}

export default ViewTypeButton;
